/* =============================================================================
   sdo-pdp-accordion-exclusive.js

   Rend les accordéons natifs de la section product-content du thème exclusifs :
   ouvrir un accordéon ferme automatiquement les autres.

   Approche : event listener "toggle" sur chaque <details>. Quand un s'ouvre,
   on ferme les autres du même groupe. Fonctionne sur tous les navigateurs
   (pas besoin de l'attribut HTML5 `name` qui n'est supporté que depuis
   Chrome 120 / Safari 17.2 / Firefox 130).

   Une garde booléenne empêche les boucles infinies (un toggle déclencherait
   un autre toggle, etc.).
   ============================================================================= */

(function () {
  'use strict';

  function initExclusiveAccordion() {
    // Cibler la section product-content (qui contient les accordéons natifs)
    const productContent = document.querySelector('product-content')
      || document.querySelector('.product-content-section');
    if (!productContent) return false;

    // Tous les <details> de la section
    const detailsList = productContent.querySelectorAll('details');
    if (detailsList.length === 0) return false;

    // Empêcher la double-init si le script tourne plusieurs fois
    if (productContent.dataset.sdoExclusiveAccInit === 'true') return true;
    productContent.dataset.sdoExclusiveAccInit = 'true';

    let isToggling = false;

    detailsList.forEach(function (details) {
      details.addEventListener('toggle', function () {
        if (isToggling) return;
        if (!details.open) return;

        isToggling = true;
        detailsList.forEach(function (other) {
          if (other !== details && other.open) {
            other.open = false;
          }
        });
        // Reset la garde après le tick courant
        setTimeout(function () {
          isToggling = false;
        }, 50);
      });
    });

    return true;
  }

  let attempts = 0;
  const MAX_ATTEMPTS = 20;

  function tryInit() {
    if (initExclusiveAccordion()) return;
    attempts++;
    if (attempts >= MAX_ATTEMPTS) return;
    setTimeout(tryInit, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryInit);
  } else {
    tryInit();
  }
})();